import {requestGet, requestPost} from '@/utils/request';

const api = {
    LIST: '/system/tag_list',
    ADD: '/system/tag_add',
    UPDATE: '/system/tag_update',
	DEL: '/system/tag_del',
    IS_EXIST_ACCOUNT: '/system/tag_is_exist_tag_name',

}

export async function tagList(queryParams) {
    return requestGet(api.LIST, queryParams);
}

export async function tagAdd(form) {
    return requestPost(api.ADD, form);
}

export async function tagUpdate(form) {
    return requestPost(api.UPDATE, form);
}

export async function tagDel(id) {
	let params = {id: id};
    return requestPost(api.DEL, params);
}

export async function tagNameIsExist(account) {
    let params = {val: account};
    return requestGet(api.IS_EXIST_ACCOUNT, params);
}

